import {
  aCancelSumoRecordSearchJob,
  mockCancelSumoRecordSearchJobOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockCancelSumoRecordSearchJobOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          cancelSumoRecordSearchJob: aCancelSumoRecordSearchJob({ ok: true }),
        },
      });
    }
  ),
];
